// 
import React from "react";
import { Field, ErrorMessage } from "formik";
import Error from "./ErrorMessage";
import { TextField, TextFieldProps } from "@mui/material";

type InputProps = {
  name: string;
  label?: string;
} & TextFieldProps;

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ name, ...rest }, ref) => {
  return (
    <>
      <Field name={name}>
        {({ field }: any) => (
          <TextField
            {...field}
            {...rest}
            fullWidth
            variant="outlined"
            inputRef={ref}
          />
        )}
      </Field>
      <Error>
        <ErrorMessage name={name} />
      </Error>
    </>
  );
});

export default Input;
